import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import RegisterHero from './components/RegisterHero';
import RegisterBenefits from './components/RegisterBenefits';
import RegisterForm from './components/RegisterForm';
import RegisterCTA from './components/RegisterCTA';

export default function Register() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <RegisterHero />
        <RegisterBenefits />
        <RegisterForm />
        <RegisterCTA />
      </main>
      <Footer />
    </div>
  );
}